// If you're adding new JSON content, make sure you prepend `export default` before the object

export default {
  sections: [
    {
      title: 'About Toscan',
      paragraphs: [
        'Toscan is on a mission to change the face of online shopping by putting the joy back into browsing.',
        `We've created a whole new online shopping experience, modelled on the world's best department stores. Our unique open-plan shop floors encourage you to explore and meander between a beautiful curation of brands and products, arriving at inspiration as you go. When something catches your eye, use your Toscan account to buy and well take care of the rest, while you carry on browsing. We check availability and won't take your payment until we get confirmation from the selected supplier.`,
        `From then on it's just the same as a regular purchase – your commercial relationship is with the supplier, with their terms and conditions and returns policy applying.`,
        `Of course, we're always here to help should you have any problems. Just email help@toscan.eu and we'll get on the case.`,
      ],
    },
    {
      title: 'Terms and Conditions',
      paragraphs: [],
      subsections: [
        {
          title: 'Context',
          paragraphs: [
            'Toscan does not sell products, we facilitate their purchase on your behalf. When you place an order we allocate it to the Supplier who is then responsible to fulfil your order.',
            'We reserve the purchase amount on your payment card at the time you place the order but do not take your payment until the order is confirmed with the supplier. You have absolute right to cancel until the point the order is confirmed by the supplier.',
            'Once the order is confirmed you become the customer of the Supplier whose usual terms, conditions and returns policy will apply.',
          ],
        },
        {
          title: 'Acceptance of terms ',
          paragraphs: ['By using Toscan you agree to be bound by these terms.'],
        },
        {
          title: 'Price',
          paragraphs: [
            'The price of a product includes VAT (where applicable) at the current rate chargeable for the type of product.',
            'If the product price including delivery at the time of confirmation of the order is less than the price quoted by us online then you will only be charged the lower price',
          ],
        },
        {
          title: 'Delivery',
          paragraphs: [
            'The price of delivery is shown to UK mainland only. A higher delivery charge may be payable to territories outside of the UK mainland.',
            "Stock products ordered should be delivered to you by the date quoted on the Supplier's order confirmation. If the Supplier is not able to fulfil an order within a reasonable time you will be given the option of cancelling or placing the product on back order.",
            'Products personalised or specifically made to your specification (including, the selection of one or more options) will be delivered by the date agreed with the Supplier.',
          ],
        },
        {
          title: 'Responsibility for quality of goods',
          paragraphs: [
            "Products' descriptions displayed by Toscan are believed to be accurate and complete. We cannot however guarantee that computer displays of colour accurately reflect the colour of actual products.",
            'The Supplier is responsible to you for the satisfactory nature of any product purchased. Toscan cannot accept liability for any error in the product descriptions nor undertake that any product purchased from any Supplier will be of satisfactory quality. Any warranties in this regard are disclaimed absolutely to the fullest extent permitted by law.',
            'This disclaimer does not affect your statutory rights in respect of the Supplier.',
          ],
        },
        {
          title: 'Returns',
          paragraphs: [
            'If you need to return a product please follow the instructions contained with the delivery packaging.',
            'Many suppliers offer more favourable returns policy than required by law but as a minimum you can return products to the Supplier and receive a refund of the price paid (including basic delivery charges) for any reason, provided you give notice to Supplier of your intention to return them within 14 days of receipt ("returns notice").',
            'If a product has been delivered before you decide to cancel, it must be returned to the Supplier without undue delay and, in any event, within 14 days of the returns notice.',
            'You are responsible for the costs of returning the products to the Supplier unless it is established that the products are faulty or not as described by the Supplier.',
            'The purchase price will be refunded to you within 14 days of the earlier of:',
            '- the date the Supplier receives the returned goods',
            '- the date on which you supply evidence to the Supplier of having returned the goods',
            'If a product is returned because it is faulty, postage and packing costs will be refunded to you along with the full cost of the product.',
            'The right to return is excluded by law in respect of products that are:',
            '- personalised or specifically made to your specification (including, the selection of options)',
            '- perishable, such as food and flowers',
            '- audio or video recordings',
            '- computer software, which you have unsealed',
            '- newspapers, periodicals or magazines',
            '- items that cannot be restored to the same physical state as they were supplied',
            'The Supplier is permitted by law to reduce the refund to reflect any reduction in the value of the goods caused by your handling them in a way which would not be permitted in a physical shop. Such amount will be deducted from the refund amount.',
            'The Supplier will communicate directly with you regarding payment for the cost of delivery, postage and packaging charges relating to returns.',
          ],
        },
        {
          title: 'Ethical supply',
          paragraphs: [
            'Suppliers featured by Toscan are encouraged to operate ethically and to provide an environment which protects their employees health, safety and basic human rights without discrimination, harsh or inhumane treatment, oppressive working hours, inadequate rates of pay or onerous terms of employment.',
          ],
        },
        {
          title: 'Links',
          paragraphs: [
            'Links to other websites and third party resources are provided for information only and should not be interpreted as an endorsement of those linked websites. Toscan is not liable for any loss or damage that may arise from use of them.',
          ],
        },
        {
          title: 'Cookies',
          paragraphs: [
            'Toscan only uses your data under UK GDPR Legitimate Interest provisions. Any cookies used are necessary to manage your account and provide the service to you. We do not use cookies for advertising or preference tracking. You can optionally agree to receive material relating to the brands featured by Toscan by indicating your consent in "My details".',
          ],
        },
        {
          title: 'Legal provisions',
          paragraphs: [
            //'Ownable is the trading name of Seeninprint Limited of The Pinnacle, 170 Midsummer Boulevard, Milton Keynes, UK',
            'These terms and conditions are effective from 1st February 2025 and supersede any and all earlier terms.',
          ],
        },
        {
          title: 'Intellectual property',
          paragraphs: [
            'All copyright and other property in the Toscan brand belongs to Toscan Ltd. No content shall be reused or published without the specific consent of Seeninprint Ltd.',
            'The word "Toscan" and the five bars logo are registered trademarks of Toscan Ltd, both when used individually and when used together.',
            "The rights in the platform, websites and content are protected by international copyright laws as well as by any relevant national law concerning copyright, authors' rights and database rights laws. All such rights are reserved.",
            'Creating and/or publishing database(s) that feature substantial parts of the content featured by Toscan is not permitted.',
          ],
        },
        {
          title: 'Misuse',
          paragraphs: [
            'This online application may not be used in any way that:',
            '- causes, or is likely to cause access to it to be interrupted, damaged or impaired',
            '- breaches any applicable local, national or international law or regulation',
            '- is unlawful or fraudulent, or has any unlawful or fraudulent purpose or effect',
            'No content is permitted that is or may become:',
            '- illegal, offensive, abusive, indecent, defamatory, discriminatory, obscene or menacing',
            '- in breach of copyright, trademark, confidence, privacy or any other right recognised by law injurious to third parties or which:',
            '- contains software viruses, chain letters, mass mailings or spam',
            '- causes harm, annoyance, inconvenience or needless anxiety to any person',
          ],
        },
        {
          title: 'Severability',
          paragraphs: [
            'Each provision of these terms operates separately. If any court or relevant authority decides that any of them are unlawful or unenforceable, the remaining provisions will remain in full force and effect.',
          ],
        },
        {
          title: 'Waiver',
          paragraphs: [
            'Lack of, or delay in, taking action to enforce these terms does not constitute the waiver of any rights.',
          ],
        },
        {
          title: 'Jurisdiction',
          paragraphs: [
            'These terms are governed by English law. The courts of England and Wales shall have exclusive jurisdiction over any dispute or claim arising',
          ],
        },
      ],
    },
  ],
};
